(function () {
  'use strict';

  var BREAKPOINT_CLASSIC_TO = 1023;
  var BREAKPOINT_DESKTOP_FROM = 1024;

  function topLevelItems(nav) {
    if (!nav) return [];
    var items = [];
    for (var i = 0; i < nav.children.length; i += 1) {
      var child = nav.children[i];
      if (child.classList && child.classList.contains('site-nav-first-level')) items.push(child);
    }
    return items;
  }

  function firstDirectChild(item, selector) {
    if (!item) return null;
    var child = item.firstElementChild;
    while (child) {
      if (child.matches && child.matches(selector)) return child;
      child = child.nextElementSibling;
    }
    return null;
  }

  function itemDropdown(item) {
    return firstDirectChild(item, '.site-nav--dropdown');
  }

  function itemIndicator(item) {
    return firstDirectChild(item, '.collapsible');
  }

  function itemTrigger(item) {
    return firstDirectChild(item, '.lbf-nav-dropdown-trigger');
  }

  function setExpanded(item, expanded) {
    var trigger = itemTrigger(item);
    var indicator = itemIndicator(item);

    item.classList.toggle('nav-hover', expanded);

    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (indicator) {
      indicator.classList.toggle('active', expanded);
      indicator.setAttribute('aria-hidden', 'true');
    }
  }

  function closeTopLevelMenus(nav, exceptItem) {
    var items = topLevelItems(nav);
    for (var i = 0; i < items.length; i += 1) {
      if (items[i] !== exceptItem && items[i].classList.contains('site-nav--has-dropdown')) {
        setExpanded(items[i], false);
      }
    }
  }

  function dropdownItemFromTarget(target) {
    if (!target || !target.closest) return null;
    var control = target.closest('.lbf-nav-dropdown-trigger, .collapsible');
    if (!control) return null;
    var item = control.parentElement;
    if (!item || !item.classList.contains('site-nav-first-level') || !item.classList.contains('site-nav--has-dropdown')) return null;
    return item;
  }

  function linkForItem(item) {
    return firstDirectChild(item, 'a');
  }

  function initAccessibleDropdownTriggers() {
    var navBar = document.querySelector('.nav-bar');
    var nav = document.getElementById('accessibleNav');
    if (!navBar || !nav || nav.getAttribute('data-lbf-dropdowns') === '1') return;

    var items = topLevelItems(nav);
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      if (!item.classList.contains('site-nav--has-dropdown')) continue;

      var link = linkForItem(item);
      if (!link) continue;

      link.classList.add('lbf-nav-dropdown-trigger');
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', item.classList.contains('nav-hover') ? 'true' : 'false');

      var dropdown = itemDropdown(item);
      if (dropdown && !dropdown.id) dropdown.id = 'lbf-dropdown-' + i;
      if (dropdown && dropdown.id) link.setAttribute('aria-controls', dropdown.id);

      var indicator = itemIndicator(item);
      if (indicator) {
        indicator.setAttribute('aria-hidden', 'true');
        indicator.setAttribute('tabindex', '-1');
      }

      item.addEventListener('mouseleave', function () {
        this.classList.remove('lbf-click-closed');
      });
    }

    nav.addEventListener('click', function (event) {
      var item = dropdownItemFromTarget(event.target);
      if (!item) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var willOpen = !item.classList.contains('nav-hover');
      closeTopLevelMenus(nav, item);
      item.classList.toggle('lbf-click-closed', !willOpen);
      setExpanded(item, willOpen);
    }, true);

    nav.addEventListener('keydown', function (event) {
      var item = dropdownItemFromTarget(event.target);
      if (!item) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        var willOpen = !item.classList.contains('nav-hover');
        closeTopLevelMenus(nav, item);
        setExpanded(item, willOpen);
      }

      if (event.key === 'Escape') {
        setExpanded(item, false);
        var trigger = itemTrigger(item);
        if (trigger) trigger.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!navBar.contains(event.target)) closeTopLevelMenus(nav);
    });

    nav.setAttribute('data-lbf-dropdowns', '1');
  }

  function initMobileDrawer() {
    var html = document.documentElement;
    var body = document.body;
    var navBar = document.querySelector('.nav-bar');
    var toggle = document.querySelector('.menu-toggle');
    var overlay = document.querySelector('.nav-bar-overlay');
    var mobileHeader = document.getElementById('mobileNavBar');

    if (!navBar || !toggle || !mobileHeader || toggle.getAttribute('data-lbf-drawer') === '1') return;

    var savedScroll = 0;

    function viewportWidth() {
      return window.innerWidth || document.documentElement.clientWidth || 0;
    }

    function isDrawerViewport() {
      return viewportWidth() <= BREAKPOINT_CLASSIC_TO;
    }

    function headerBottom() {
      var rect = mobileHeader.getBoundingClientRect();
      return Math.max(0, Math.round(rect.bottom));
    }

    function applyDrawerTop() {
      if (!html.classList.contains('show-nav') || !isDrawerViewport()) return;
      navBar.style.setProperty('top', headerBottom() + 'px', 'important');
    }

    function lockBody() {
      savedScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
      body.style.position = 'fixed';
      body.style.top = '-' + savedScroll + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    }

    function unlockBody() {
      var top = body.style.top;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      var y = top ? Math.abs(parseInt(top, 10) || 0) : savedScroll;
      window.scrollTo(0, y);
    }

    function openDrawer() {
      if (!isDrawerViewport()) return;
      html.classList.add('show-nav');
      body.classList.add('show-nav');
      applyDrawerTop();
      lockBody();
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      if (!html.classList.contains('show-nav')) return;
      html.classList.remove('show-nav');
      body.classList.remove('show-nav');
      navBar.style.removeProperty('top');
      unlockBody();
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (event) {
      if (!isDrawerViewport()) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (html.classList.contains('show-nav')) closeDrawer();
      else openDrawer();
    }, true);

    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (!isDrawerViewport()) return;
        event.preventDefault();
        closeDrawer();
      }, true);
    }

    window.addEventListener('resize', function () {
      if (!isDrawerViewport()) closeDrawer();
      else applyDrawerTop();
    });

    window.addEventListener('orientationchange', applyDrawerTop);
    window.addEventListener('pageshow', applyDrawerTop);

    toggle.setAttribute('data-lbf-drawer', '1');
  }

  function initMegaMenuTouchScrollFix() {
    var navBar = document.querySelector('.nav-bar');
    if (!navBar || navBar.getAttribute('data-lbf-mega-touch') === '1') return;

    var startX = 0;
    var startY = 0;

    function openItem() {
      if ((window.innerWidth || document.documentElement.clientWidth || 0) < BREAKPOINT_DESKTOP_FROM) return null;

      return navBar.querySelector(
        '#accessibleNav > li.site-nav--has-dropdown.nav-hover, #accessibleNav > li.site-nav--has-dropdown:hover'
      );
    }

    navBar.addEventListener('touchstart', function (event) {
      var open = openItem();
      if (!open || !event.touches || event.touches.length !== 1) return;

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      event.stopPropagation();
    }, { passive: true, capture: true });

    navBar.addEventListener('touchmove', function (event) {
      var open = openItem();
      if (!open || !event.touches || event.touches.length !== 1) return;

      var dx = Math.abs(event.touches[0].clientX - startX);
      var dy = Math.abs(event.touches[0].clientY - startY);
      if (dx > 4 || dy > 4) event.stopPropagation();
    }, { passive: true, capture: true });

    navBar.addEventListener('touchend', function (event) {
      var open = openItem();
      if (!open) return;

      event.stopPropagation();
      if (!open.contains(event.target)) {
        open.classList.remove('nav-hover');
      }
    }, { passive: true, capture: true });

    navBar.setAttribute('data-lbf-mega-touch', '1');
  }

  function initDesktopHoverClose() {
    var nav = document.getElementById('accessibleNav');
    if (!nav || nav.getAttribute('data-lbf-desktop-hover') === '1') return;

    var currentOpen = null;
    var closeTimer = 0;

    function desktop() {
      return (window.innerWidth || document.documentElement.clientWidth || 0) >= BREAKPOINT_DESKTOP_FROM;
    }

    function scheduleClose(item) {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        if (item && !item.matches(':hover')) setExpanded(item, false);
      }, 150);
    }

    nav.addEventListener('mouseover', function (event) {
      if (!desktop()) return;
      var item = event.target.closest && event.target.closest('#accessibleNav > li.site-nav-first-level.site-nav--has-dropdown');
      if (!item || !nav.contains(item)) return;

      window.clearTimeout(closeTimer);
      if (currentOpen && currentOpen !== item) setExpanded(currentOpen, false);
      setExpanded(item, true);
      currentOpen = item;
    });

    nav.addEventListener('mouseout', function (event) {
      if (!desktop()) return;
      var item = event.target.closest && event.target.closest('#accessibleNav > li.site-nav-first-level.site-nav--has-dropdown');
      if (!item || !nav.contains(item)) return;

      var related = event.relatedTarget;
      if (related && item.contains(related)) return;
      scheduleClose(item);
    });

    nav.setAttribute('data-lbf-desktop-hover', '1');
  }

  function init() {
    initAccessibleDropdownTriggers();
    initMobileDrawer();
    initMegaMenuTouchScrollFix();
    initDesktopHoverClose();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
}());

(function () {
  'use strict';

  var sequence = 0;

  function isMobile() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function topItems(nav) {
    var items = [];
    for (var i = 0; i < nav.children.length; i += 1) {
      var item = nav.children[i];
      if (
        item.classList &&
        item.classList.contains('site-nav-first-level') &&
        item.classList.contains('site-nav--has-dropdown')
      ) {
        items.push(item);
      }
    }
    return items;
  }

  function directTrigger(item) {
    for (var i = 0; i < item.children.length; i += 1) {
      if (item.children[i].matches('a.lbf-nav-dropdown-trigger, a.level1-title')) {
        return item.children[i];
      }
    }
    return null;
  }

  function indicator(item) {
    return item.querySelector(':scope > .collapsible.level1, :scope > a > .collapsible.level1');
  }

  function resetNested(item) {
    var nestedItems = item.querySelectorAll('li.lbf-level2-open');
    for (var i = 0; i < nestedItems.length; i += 1) {
      nestedItems[i].classList.remove('lbf-level2-open');
      var trigger = nestedItems[i].querySelector(':scope > a.level2-title');
      var nestedIndicator = nestedItems[i].querySelector(':scope > .collapsible.level2, :scope > a > .collapsible.level2');
      var dropdown = nestedItems[i].querySelector(':scope > .site-nav--dropdown');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (nestedIndicator) nestedIndicator.classList.remove('active');
      if (dropdown) dropdown.style.removeProperty('display');
    }
  }

  function setItemState(item, open) {
    var trigger = directTrigger(item);
    var icon = indicator(item);
    item.classList.toggle('nav-hover', open);
    item.classList.remove('lbf-click-closed');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (icon) icon.classList.toggle('active', open);
    if (!open) resetNested(item);
  }

  function reconcile(nav, wantedItem) {
    var items = topItems(nav);
    for (var i = 0; i < items.length; i += 1) {
      setItemState(items[i], items[i] === wantedItem);
    }
  }

  function topItemFromTarget(nav, target) {
    if (!target || !target.closest) return null;
    var control = target.closest('.lbf-nav-dropdown-trigger, .collapsible.level1');
    if (!control) return null;
    var item = control.closest('li.site-nav-first-level.site-nav--has-dropdown');
    if (!item || item.parentElement !== nav) return null;
    return item;
  }

  function scheduleReconcile(nav, wantedItem) {
    var ticket = ++sequence;
    var settle = function () {
      if (ticket !== sequence) return;
      reconcile(nav, wantedItem);
    };
    window.setTimeout(settle, 0);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(settle);
    });
    window.setTimeout(settle, 180);
  }

  function init() {
    var nav = document.getElementById('accessibleNav');
    if (!nav || nav.getAttribute('data-lbf-mobile-state-fix') === '1') return;
    nav.setAttribute('data-lbf-mobile-state-fix', '1');

    document.addEventListener('click', function (event) {
      if (!isMobile() || !nav.contains(event.target)) return;
      var item = topItemFromTarget(nav, event.target);
      if (!item) return;
      var wantedItem = item.classList.contains('nav-hover') ? null : item;
      scheduleReconcile(nav, wantedItem);
    }, true);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        if (!document.documentElement.classList.contains('show-nav')) {
          sequence += 1;
          reconcile(nav, null);
        }
      });
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('pageshow', function () {
      if (isMobile()) reconcile(nav, null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
}());

(function () {
  'use strict';

  function isMobile() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function init() {
    var nav = document.getElementById('accessibleNav');
    if (!nav || nav.getAttribute('data-lbf-mobile-input-stable') === '1') return;
    nav.setAttribute('data-lbf-mobile-input-stable', '1');

    /*
     * The legacy Timber navigation installs mouseenter/mouseleave handlers and,
     * after a hover, a body touchstart handler. On iOS that body handler closes
     * the open accordion before the generated click is dispatched. The rows
     * then move beneath the finger and Safari can activate the wrong link.
     */
    function isolateLegacyInput(event) {
      if (!isMobile()) return;
      event.stopImmediatePropagation();
    }

    nav.addEventListener('touchstart', isolateLegacyInput, true);
    nav.addEventListener('mouseover', isolateLegacyInput, true);
    nav.addEventListener('mouseout', isolateLegacyInput, true);

    function detachLegacyHoverHandlers() {
      if (!isMobile() || !window.jQuery) return;
      window.jQuery(nav)
        .find('.site-nav--has-dropdown')
        .off('mouseenter mouseleave');
    }

    detachLegacyHoverHandlers();
    window.setTimeout(detachLegacyHoverHandlers, 0);
    window.addEventListener('load', function () {
      window.setTimeout(detachLegacyHoverHandlers, 0);
    });
    window.addEventListener('resize', function () {
      window.setTimeout(detachLegacyHoverHandlers, 0);
    }, { passive: true });
    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(detachLegacyHoverHandlers, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
